import React from 'react';
import { Brain, Code2, Shield } from 'lucide-react';
import { Card } from './ui/card';

const services = [
  {
    icon: Brain,
    title: 'AI/ML Engineering',
    description: 'Creating intelligent models with GANs and CNNs',
    details: 'Specializing in generative adversarial networks, transfer learning, and computer vision applications. Building models that learn, adapt, and solve complex problems.',
    color: 'from-blue-500 to-cyan-500'
  },
  {
    icon: Code2,
    title: 'Full-Stack Development',
    description: 'Building end-to-end web applications',
    details: 'Crafting scalable backend systems with Django and Node.js, paired with responsive frontends using React. From database design to deployment.',
    color: 'from-cyan-500 to-blue-600'
  },
  {
    icon: Shield,
    title: 'Cybersecurity',
    description: 'Securing systems with intrusion detection',
    details: 'Implementing AI-powered intrusion detection systems. Using machine learning to identify and prevent security threats before they cause damage.',
    color: 'from-blue-600 to-cyan-400'
  }
];

const WhatIDo = () => {
  return (
    <section className="min-h-screen bg-gradient-to-b from-[#0a0a0a] via-[#0d0d1a] to-[#0a0a0a] py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-5xl md:text-6xl font-bold text-center text-white mb-8 drop-shadow-[0_0_20px_rgba(59,130,246,0.3)]">
          What I Do
        </h2>
        <p className="text-xl text-gray-400 text-center mb-20 max-w-3xl mx-auto">
          Combining technical expertise with creative problem-solving
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="group bg-[#0f0f1a] border-gray-800 hover:border-blue-500/50 p-8 transition-all duration-500 hover:scale-105 hover:shadow-[0_0_40px_rgba(59,130,246,0.2)] cursor-pointer overflow-hidden relative backdrop-blur-sm"
              >
                {/* Gradient overlay on hover */}
                <div className={`absolute inset-0 bg-gradient-to-br ${service.color} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}></div>
                
                <div className="relative z-10">
                  <div className="mb-6 inline-block p-4 bg-gradient-to-br from-blue-600/20 to-cyan-600/20 rounded-xl group-hover:scale-110 transition-transform duration-300 shadow-[0_0_20px_rgba(59,130,246,0.2)] group-hover:shadow-[0_0_30px_rgba(59,130,246,0.4)]">
                    <Icon className="w-10 h-10 text-blue-400 group-hover:text-cyan-400 transition-colors" />
                  </div>
                  
                  <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-blue-300 transition-colors drop-shadow-[0_0_10px_rgba(59,130,246,0)]  group-hover:drop-shadow-[0_0_15px_rgba(59,130,246,0.4)]">
                    {service.title}
                  </h3>
                  
                  <p className="text-lg text-gray-400 mb-4">
                    {service.description}
                  </p>
                  
                  <p className="text-gray-500 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-500 max-h-0 group-hover:max-h-40">
                    {service.details}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatIDo;